import { FigmakeDashboard } from '@/components/figmamake';

export default function FigmakeDashboardPage() {
  return <FigmakeDashboard />;
}
